import { DxfFetcher } from './DxfFetcher.js'

export default {
  extensions: ['dxf'],
  async load(url, options={}) {
    const fetcher = new DxfFetcher(url, options.encoding || 'utf-8')
    return await fetcher.Fetch(options.progressCbk)
    // devuelve CadJson - la forma que ya produce el parser de dxf
  }
}
